import DashboardLayout from "src/pages/Dashboard/Layout/DashboardLayout.vue";
import AccessLogComponent from "src/components/AccessLogComponent.vue";
import AutorefillQueuePage from "src/pages/Prescription/AutorefillQueuePage.vue";
import MedSyncQueuePage from "src/pages/MedSync/MedSyncQueuePage.vue";
import MedSyncOpportunitiesPage from "src/pages/MedSync/MedSyncOpportunitiesPage.vue";
import CategoryComponent from "src/components/CategoryComponent.vue";
import ConsultationsPage from "src/pages/Consultations/ConsultationsPage.vue";
import ConsignmentQueuePage from "src/pages/Consignments/ConsignmentQueuePage.vue";
import DashboardConfigurationPage from "@/pages/Dashboard/Dashboard/DashboardConfigurationPage.vue";
import AdhocDashboard from "@/pages/Dashboard/Dashboard/AdHocDashboard.vue";
import DispensedPage from "src/pages/Reports/DispensedPage.vue";
import DoctorDashboard from "@/pages/Doctor/DoctorDashboard.vue";
import DoctorDetailsPage from "src/pages/Doctor/DoctorDetailsPage.vue";
import DoctorMergePage from "src/pages/Doctor/DoctorMergePage.vue";
import DoctorFollowUpQueue from "src/pages/Doctor/DoctorFollowUpQueue.vue";
import DrugComponent from "src/pages/Drug/DrugDetailsPage.vue";
import NonGSDDDrugDetailsPage from "src/pages/Drug/NonGSDDDrugDetailsPage.vue";
import CompoundDrugDetailsPage from "src/pages/Drug/CompoundDrugDetailsPage.vue";
import CompoundFillingPage from "src/pages/Compound/CompoundFillingPage.vue";
import CompoundBatchAuditPage from "src/pages/Compound/CompoundBatchAuditPage.vue";
import DrugDashboard from "@/pages/Drug/DrugDashboard.vue";
import ProgramDashboard from "@/pages/Program/ProgramDashboard.vue";
import HistoryComponent from "src/components/HistoryComponent.vue";
import InventoryReportPage from "src/pages/Reports/InventoryReportPage.vue";
import IngestionComponent from "src/components/IngestionComponent.vue";
import ManualFaxComponent from "src/components/ManualFaxComponent.vue";
import IncompleteAnswersQueuePage from "src/pages/Questionary/IncompleteAnswersQueuePage.vue";
import InventoryBatchQueuePage from "@/pages/Inventory/InventoryBatchQueuePage.vue";
import MergePatientsPage from "src/pages/Patient/MergePatientsPage.vue";
import MergePatientsQueuePage from "@/pages/Patient/PatientMergeQueuePage.vue";
import NotFound from "@/pages/Special/NotFoundPage.vue";
import AcceptanceConfigurationMaintenancePage from "src/pages/Acceptance/AcceptanceConfigurationMaintenancePage.vue";
import PriceSchedulePage from "src/pages/PriceSchedule/PriceSchedulePage.vue";
import PatientDetailsPage from "src/pages/Patient/PatientDetailsPage.vue";
import PatientDashboardPage from "src/pages/Patient/PatientDashboardPage.vue";
import OnlineOrderQueue from "@/pages/PatientWeb/OnlineOrderQueue.vue";
import PartialPaymentQueue from "@/pages/PatientWeb/PartialPaymentQueue.vue";
import OrderDetailsPage from "src/pages/Order/OrderDetailsPage.vue";
import OTCItemDetailsPage from "src/pages/OTCItem/OTCItemDetailsPage.vue";
import CasesPage from "src/pages/Cases/CasesPage.vue";
import PatientInsuranceQueue from "src/pages/PatientInsuranceUploads/PatientInsuranceQueue.vue";
import PatientWebAllergyUpdateQueue from "src/pages/PatientWeb/PatientWebAllergyUpdateQueue.vue";
import PrintQueuePage from "src/pages/Order/PrintQueuePage.vue";
import TransferMyRxQueuePage from "@/pages/Transfer/TransferMyRxQueuePage.vue";
import OrderAuditConfigPage from "@/pages/Order/OrderAuditConfigPage.vue";
import OrderAuditQueuePage from "@/pages/Order/OrderAuditQueuePage.vue";
import OrderAuditDetails from "@/pages/Order/OrderAuditDetails.vue";
import VerifiedNotShippedQueue from "@/pages/Order/VerifiedNotShippedQueue.vue";
import PendingForBillingQueuePage from "src/pages/Prescription/PendingForBillingQueuePage.vue";
import PlanDetailsPage from "src/pages/Plan/PlanDetailsPage.vue";
import PharmacyBenefitManagerPage from "src/pages/PharmacyBenefitManager/PharmacyBenefitManagerPage.vue";
import ProviderWebPage from "src/pages/ProviderWeb/ProviderWebPage.vue";
import FailedFaxComponent from "src/pages/Fax/FailedFaxComponent.vue";
import PrescriptionDetailsPage from "src/pages/Prescription/PrescriptionDetailsPage.vue";
import PrescriptionVerificationDetailsPage
    from "src/pages/PrescriptionVerification/PrescriptionVerificationDetailsPage.vue";
import RxAuditVerificationPage from "src/pages/PrescriptionVerification/RxAuditVerificationPage.vue";
import PriorAuthorizationAutosendConfigPage from "@/pages/PriorAuthorization/PriorAuthorizationAutosendConfigPage.vue";
import PV1QueuePage from "src/pages/PrescriptionVerification/PV1QueuePage.vue";
import ProgramDetailsPage from "src/pages/Program/ProgramDetailsPage.vue";
import PendingToAcceptErrorsPage from "src/pages/DispenseError/PendingToAcceptErrorsPage.vue";
import PriorAuthorizationListPage from "src/pages/PriorAuthorization/PriorAuthorizationListPage.vue";
import ElectronicPriorAuthorizationListPage
    from "src/pages/PriorAuthorization/ElectronicPriorAuthorizationListPage.vue";
import PrescriptionOnHoldQueue from "@/pages/Prescription/PrescriptionOnHoldQueue.vue";
import RefillRequestBatchPage from "src/pages/RefillRequestBatch/RefillRequestBatchPage.vue";
import PharmacyDetailPage from "@/pages/Pharmacy/PharmacyDetailPage.vue";
import PharmacistDetailPage from "@/pages/Pharmacist/PharmacistDetailPage.vue";
import ReportsComponent from "src/components/ReportsComponent.vue";
import ReportedErrorsPage from "src/pages/DispenseError/ReportedErrorsPage.vue";
import ReversalQueuePage from "src/pages/Prescription/ReversalQueuePage.vue";
import RxTransferQueuePage from "src/pages/Transfer/RxTransferQueuePage.vue";
import BulkTransferOutPage from "src/pages/Transfer/BulkTransferOutPage.vue";
import SigMaintenancePage from "src/pages/SigTranslation/SigMaintenancePage.vue";
import SigAdministrationCategoriesPage from "src/pages/SigTranslation/SigAdministrationCategoriesPage.vue";
import StoreDetailsPage from "src/pages/Store/StoreDetailsPage.vue";
import UserComponent from "src/components/User/UserComponent.vue";
import VendorDetailsPage from "src/pages/Vendor/VendorDetailsPage.vue";
import VerificationQueuePage from "src/pages/PrescriptionVerification/VerificationQueuePage.vue";
import PickupQueuePage from "src/pages/Order/PickupQueuePage.vue";
import Voicemails from "src/pages/Voicemail/VoicemailsPage.vue";
import PMPStatusPage from "src/pages/Prescription/PMPStatusPage.vue";
import DrugShortageReportPage from "src/pages/Reports/DrugShortageReportPage.vue";
import SurplusReportsPage from "src/pages/Surplus/SurplusReportsPage.vue";
import ConfigurationPage from "@/pages/Configuration/ConfigurationPage.vue";
import LabelTemplatesPage from "@/pages/Configuration/LabelTemplatesPage.vue";
import ReturnToSenderPage from "src/pages/Order/ReturnToSenderPage.vue";
import AuditTrackingPage from "src/pages/AuditTracking/AuditTrackingPage.vue";
import PatientAssistanceProgramQueue from "src/pages/PatientAssistanceProgram/PatientAssistanceProgramQueue.vue";
import TransferRxReportPage from "src/components/TransferReport.vue";
import PlaidPage from "src/pages/Plaid/PlaidPage.vue";
import Ordering from "@/pages/EDI/Ordering.vue";
import EDIOrderDetails from "@/pages/EDI/OrderDetails.vue";
import FlexEmbed from "@/pages/FlexEmbed.vue";
import Login from "@/pages/Dashboard/Pages/Login.vue";
import ActiveQueue from "@/pages/Prescription/ActiveQueuePage.vue";
import PeriodicInventoriesPage from "@/pages/Inventory/PeriodicInventoriesPage.vue";
import PeriodicInventoryDetailsPage from "@/pages/Inventory/PeriodicInventoryDetailsPage.vue";
import CallLogPage from "@/pages/CallLog/CallLog.vue";
import NotificationListPage from "@/pages/Notifications/NotificationListPage.vue";
import InventoryPARLevelsPage from "@/pages/Inventory/InventoryParLevelsPage.vue";
import ExpiredOnOrderPage from "@/pages/Prescription/ExpiredOnOrderPage.vue";
import UnauthorizedPage from "@/pages/Special/UnauthorizedPage.vue";

const InventoryLocationsPage = () => import("@/pages/Inventory/InventoryLocationsPage.vue");
const LabelPrinters = () => import("@/pages/Printers/LabelPrintersPage.vue");
const TeamsPage = () => import("@/pages/Teams/TeamsPage.vue");
const TasksPage = () => import("@/pages/Tasks/TasksPage.vue");
const FillingPage = () => import("@/pages/Prescription/FillingPage.vue");
const ShippingPage = () => import("@/pages/Prescription/ShippingPage.vue");
const PrescriberContactTemplatesPage = () => import("@/pages/Doctor/PrescriberContactTemplatesPage.vue");
const TaskTriggersPage = () => import("@/pages/Tasks/TaskTriggersPage.vue");
const PriorAuthFaxTemplatesPage = () => import("@/pages/PriorAuthorization/PriorAuthFaxTemplatesPage.vue");
const PatientUniqueIdLookupPage = () => import("@/pages/Patient/PatientUniqueIdLookupPage.vue");
const CustomTextTemplatesPage = () => import("@/pages/CustomTextTemplatesPage.vue");
const TaskCompletionFormsPage = () => import("@/pages/Tasks/TaskCompletionFormsPage.vue");
const TaskCompletionAnswersMergeDocumentsPage = () => import("@/pages/TaskCompletionAnswersMergeDocumentsPage.vue");
const SystemHealthPage = () => import("@/pages/Configuration/SystemHealthPage.vue");
const FRMPortalManagementPage = () => import("@/pages/FRMPortal/FRMPortalManagementPage.vue");
const EncryptionKeysPage = () => import("@/pages/Configuration/EncryptionKeysPage.vue");

// Page Headers
import DefaultHeader from "src/pages/Dashboard/DefaultHeader.vue";
import Content from "@/pages/Dashboard/Layout/Content.vue";

// Dashboard pages
const Dashboard = () =>
    import(
        /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Dashboard/Dashboard.vue"
    );
const DashboardHeader = () =>
    import(
        /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Dashboard/DashboardHeader.vue"
    );

const maintenanceMenu = {
    path: "/maintenance",
    component: DashboardLayout,
    redirect: "/maintenance/patient",
    name: "Maintenance",
    children: [
        {
            path: "price-schedule/:id",
            name: "PriceScheduleDetail",
            components: { default: PriceSchedulePage, header: DefaultHeader, },
            meta: { title: "Price Schedule", },
        },
        {
            path: "price-schedule",
            name: "PriceSchedule",
            components: { default: PriceSchedulePage, header: DefaultHeader, },
            meta: {
                title: "Price Schedule",
                permission: "Maintenance/Price Schedule"
            },
        },
        {
            path: "acceptance-configuration/:id",
            name: "AcceptanceConfigurationDetails",
            components: { default: AcceptanceConfigurationMaintenancePage, header: DefaultHeader },
            meta: { title: "Acceptance Configuration" }
        },
        {
            path: "acceptance-configuration",
            name: "AcceptanceConfiguration",
            components: { default: AcceptanceConfigurationMaintenancePage, header: DefaultHeader },
            meta: {
                title: "Acceptance Configuration",
                permission: "Maintenance/Acceptance Configuration"
            }
        },
        {
            path: "patient/:id",
            name: "PatientDetails",
            components: { default: PatientDetailsPage, header: DefaultHeader },
            meta: { title: "Patient" }
        },
        {
            path: "patient",
            name: "Patient",
            components: { default: PatientDetailsPage, header: DefaultHeader },
            meta: {
                title: "Patient",
                permission: "Maintenance/Patient"
            }
        },
        {
            path: "doctor/:id",
            name: "DoctorDetails",
            components: { default: DoctorDetailsPage, header: DefaultHeader },
            meta: { title: "Doctor" }
        },
        {
            path: "doctor",
            name: "Doctor",
            components: { default: DoctorDetailsPage, header: DefaultHeader },
            meta: {
                title: "Doctor",
                permission: "Maintenance/Doctor"
            }
        },
        {
            path: "merge-doctor",
            name: "Merge-Doctor",
            components: { default: DoctorMergePage, header: DefaultHeader },
            meta: {
                title: "Merge Doctor",
                permission: "Maintenance/Merge Doctors"
            }
        },
        {
            path: "vendor",
            name: "Vendor",
            components: { default: VendorDetailsPage, header: DefaultHeader },
            meta: {
                title: "Vendor",
                permission: "Maintenance/Vendor"
            }
        },
        {
            path: "store",
            name: "Store-New",
            components: { default: StoreDetailsPage, header: DefaultHeader },
            meta: {
                title: "Store",
                anyPermission: ["Maintenance/Store", "Maintenance/Pharmacist of Record"]
            }
        },
        {
            path: "store/:id",
            name: "Store",
            components: { default: StoreDetailsPage, header: DefaultHeader },
            meta: {
                title: "Store",
                anyPermission: ["Maintenance/Store", "Maintenance/Pharmacist of Record"]
            }
        },
        {
            path: "drug/:id",
            name: "Drug",
            components: { default: DrugComponent, header: DefaultHeader },
            meta: {
                title: "Drug",
                permission: "Maintenance/Drug/Read"
            }
        },
        {
            path: "drug",
            name: "Drug-New",
            components: { default: DrugComponent, header: DefaultHeader },
            meta: {
                title: "Drug",
                permission: "Maintenance/Drug/Read"
            }
        },
        {
            path: "non-gsdd-drug",
            name: "Non-GSDD-Drug-New",
            components: {
                default: NonGSDDDrugDetailsPage,
                header: DefaultHeader
            },
            meta: {
                title: "Non GSDD Drug",
                permission: "Maintenance/NonGsdd Drug/Read"
            }
        },
        {
            path: "non-gsdd-drug/:id",
            name: "Non-GSDD-Drug",
            components: {
                default: NonGSDDDrugDetailsPage,
                header: DefaultHeader
            },
            meta: {
                title: "Non GSDD Drug",
                permission: "Maintenance/NonGsdd Drug/Read"
            }
        },
        {
            path: "compound-drug/:id",
            name: "Compound-Drug",
            components: {
                default: CompoundDrugDetailsPage,
                header: DefaultHeader
            },
            meta: {
                title: "Compound Drug",
                permission: "Maintenance/Compound Drug/Read"
            }
        },
        {
            path: "compound-drug",
            name: "Compound-Drug-New",
            components: {
                default: CompoundDrugDetailsPage,
                header: DefaultHeader
            },
            meta: {
                title: "Compound Drug",
                permission: "Maintenance/Compound Drug/Read"
            }
        },
        {
            path: "compound-filling/:compoundId?/:mode?",
            name: "CompoundFillingPage",
            components: {
                default: CompoundFillingPage,
                header: DefaultHeader
            },
            meta: {
                title: "Compound Preparation",
                permission: "Maintenance/Compound Drug/Update"
            },
            props: {
                default: true
            }
        },
        {
            path: "compound-batch-audit/:compoundId?",
            name: "CompoundBatchAudit",
            components: {
                default: CompoundBatchAuditPage,
                header: DefaultHeader
            },
            meta: {
                title: "Compound Batch Audit",
                permission: "Maintenance/Compound Drug/Read"
            },
            props: {
                default: true
            }
        },
        {
            path: "category",
            name: "Category",
            components: { default: CategoryComponent, header: DefaultHeader },
            meta: {
                title: "Drug Category",
                permission: "Admin/Category"
            }
        },
        {
            path: "program/:id",
            name: "ProgramDetails",
            components: { default: ProgramDetailsPage, header: DefaultHeader },
            meta: {
                title: "Program",
                permission: "Admin/Program"
            }
        },
        {
            path: "program",
            name: "Program",
            components: { default: ProgramDetailsPage, header: DefaultHeader },
            meta: {
                title: "Program",
                permission: "Admin/Program"
            }
        },
        {
            path: "otc-Item",
            name: "OTCItem",
            components: { default: OTCItemDetailsPage, header: DefaultHeader },
            meta: {
                title: "OTC Item",
                permission: "Admin/OTC Items"
            }
        },
        {
            path: "consultation/:consultationId?",
            name: "Consultation",
            components: { default: ConsultationsPage, header: DefaultHeader },
            meta: {
                title: "Consultations",
                permission: "Pharmacists/Consultations/Complete Consultation"
            }
        },
        {
            path: "plan",
            name: "Plan",
            components: { default: PlanDetailsPage, header: DefaultHeader },
            meta: { title: "Plan" }
        },
        {
            path: "pharmacyBenefitManager/:id",
            name: "PharmacyBenefitManagerDetails",
            components: { default: PharmacyBenefitManagerPage, header: DefaultHeader },
            meta: { title: "Pharmacy Benefit Manager" }
        },
        {
            path: "pharmacyBenefitManager",
            name: "PharmacyBenefitManager",
            components: { default: PharmacyBenefitManagerPage, header: DefaultHeader },
            meta: {
                title: "Pharmacy Benefit Manager",
                permission: "Admin/Pharmacy Benefit Manager"
            }
        },
        {
            path: "users",
            name: "Users",
            components: { default: UserComponent, header: DefaultHeader },
            meta: {
                title: "Users",
                permission: "Admin/Users"
            }
        },
        {
            path: "teams",
            name: "Teams",
            components: { default: TeamsPage, header: DefaultHeader },
            meta: {
                title: "Teams",
                permission: "Admin/Teams"
            }
        },
        {
            path: "dashboard-configuration",
            name: "DashboardConfiguration",
            components: {
                default: DashboardConfigurationPage,
                header: DefaultHeader
            },
            meta: {
                title: "Dashboard Configuration",
                permission: "Admin/Configuration"
            }
        },
        {
            path: "provider-web",
            name: "ProviderWeb",
            components: { default: ProviderWebPage, header: DefaultHeader },
            meta: {
                title: "Provider Web Management",
                permission: "Admin/Provider Web Management"
            }
        },
        {
            path: "frm-web",
            name: "FRMPortal",
            components: { default: FRMPortalManagementPage, header: DefaultHeader },
            meta: {
                title: "Field Reimbursement Manager Web Management",
                permission: "Admin/FRM Web Management"
            }
        },
        {
            path: "pa-autosend-config",
            name: "PAAutosendConfiguration",
            components: {
                default: PriorAuthorizationAutosendConfigPage,
                header: DefaultHeader
            },
            meta: {
                title: "PA Autosend Configuration",
                permission: "Admin/PA Autosend Config"
            }
        },
        {
            path: "faxes/failed",
            name: "FaxesFailed",
            components: { default: FailedFaxComponent, header: DefaultHeader },
            meta: {
                title: "Faxes - Failed",
                permission: "Processing/Failed Faxes"
            },
        },
        {
            path: "case",
            name: "Cases",
            components: { default: CasesPage, header: DefaultHeader },
            props: { default: { defaultStatus: 'opened' } },
            meta: {
                title: "Cases",
                anyPermission: ["Compliance/Cases", "Compliance/Edit Cases", "Compliance/View Cases", "Compliance/Accept Cases"]
            }
        },
        {
            path: "case/:id",
            name: "CaseDetail",
            components: { default: CasesPage, header: DefaultHeader },
            props: { default: true },
            meta: {
                title: "Case Details",
                anyPermission: ["Compliance/Cases", "Compliance/Edit Cases", "Compliance/View Cases", "Compliance/Accept Cases"]
            }
        },
        {
            path: "case/opened",
            name: "CasesOpened",
            components: { default: CasesPage, header: DefaultHeader },
            props: { default: { defaultStatus: 'opened' } },
            meta: {
                title: "Cases - Opened",
                anyPermission: ["Compliance/Cases", "Compliance/Edit Cases", "Compliance/View Cases"]
            }
        },
        {
            path: "case/resolved",
            name: "CasesResolved",
            components: { default: CasesPage, header: DefaultHeader },
            props: { default: { defaultStatus: 'resolved' } },
            meta: {
                title: "Cases - Resolved",
                permission: "Compliance/Accept Cases"
            }
        },
        {
            path: "case/completed",
            name: "CasesCompleted",
            components: { default: CasesPage, header: DefaultHeader },
            props: { default: { defaultStatus: 'completed' } },
            meta: {
                title: "Cases - Completed",
                permission: "Compliance/Accept Cases"
            }
        },
        {
            name: "SigMaintenance",
            path: "Sig-Maintenance",
            components: { default: SigMaintenancePage, header: DefaultHeader },
            meta: {
                title: "Sig",
                permission: "Admin/Sig Translations"
            }
        },
        {
            name: "SigAdministrationCategories",
            path: "Sig-Administration-Categories",
            components: { default: SigAdministrationCategoriesPage, header: DefaultHeader },
            meta: {
                title: "Sig Administration Categories",
                permission: "Admin/Sig Translations"
            }
        },
        {
            name: "MergePatientsPage",
            path: "merge-patients/:sourcePatientId?/:targetPatientId?",
            components: { default: MergePatientsPage, header: DefaultHeader },
            meta: {
                title: "Merge Patients"
            },
            props: true
        },
        {
            name: "PatientMergeQueue",
            path: "merge-patients-queue",
            components: { default: MergePatientsQueuePage, header: DefaultHeader },
            meta: {
                title: "Merge Patients Queue",
                permission: "Maintenance/Merge Patients"
            }
        },
        {
            name: "RefillRequestBatchPage",
            path: "refill-request-batch",
            components: {
                default: RefillRequestBatchPage,
                header: DefaultHeader
            },
            meta: {
                title: "Refill Request Batch",
                permission: "Maintenance/Refill Request Batch"
            }
        },
        {
            name: "PharmacyDetail",
            path: "stored-pharmacy/:pharmacyId?",
            components: {
                default: PharmacyDetailPage,
                header: DefaultHeader
            },
            meta: { title: "Stored Pharmacies" },
            props: {
                default: true
            }
        },
        {
            name: "PharmacistDetail",
            path: "stored-pharmacist",
            components: {
                default: PharmacistDetailPage,
                header: DefaultHeader
            },
            meta: { title: "Stored Pharmacists" }
        },
        {
            name: "ConfigurationPage",
            path: "configuration",
            components: {
                default: ConfigurationPage,
                header: DefaultHeader
            },
            meta: {
                title: "Configuration",
                permission: "Admin/Configuration"
            }
        },
        {
            name: "SystemHealthPage",
            path: "system-health",
            components: {
                default: SystemHealthPage,
                header: DefaultHeader
            },
            meta: {
                title: "System Health",
                permission: "Maintenance/System Health"
            }
        },
        {
            name: "LabelTemplatesPage",
            path: "label-templates",
            components: {
                default: LabelTemplatesPage,
                header: DefaultHeader
            },
            meta: {
                title: "Label Templates",
                permission: "Admin/Label Templates"
            }
        },
        {
            name: "LabelPrinters",
            path: "label-printers",
            components: {
                default: LabelPrinters,
                header: DefaultHeader
            },
            meta: {
                title: "Label Printers",
                permission: "Admin/Label Printers"
            }
        },
        {
            name: "PeriodicInventories",
            path: "periodic-inventories",
            components: {
                default: PeriodicInventoriesPage,
                header: DefaultHeader
            },
            meta: {
                title: "Periodic Inventories",
                permission: "Maintenance/Periodic Inventory"
            }
        },
        {
            name: "PeriodicInventory",
            path: "periodic-inventories/:id",
            components: {
                default: PeriodicInventoryDetailsPage,
                header: DefaultHeader
            },
            meta: {
                title: "Periodic Inventory",
                permission: "Maintenance/Periodic Inventory"
            },
            props: {
                default: true
            }
        },
        {
            name: "InventoryPARLevels",
            path: "inventory-par",
            components: {
                default: InventoryPARLevelsPage,
                header: DefaultHeader
            },
            meta: {
                title: "Inventory PAR Levels",
                permission: "Purchasing/Inventory PAR Levels"
            }
        },
        {
            name: "InventoryLocations",
            path: "inventory-locations",
            components: {
                default: InventoryLocationsPage,
                header: DefaultHeader
            },
            meta: {
                title: "Inventory Locations",
                permission: "Maintenance/Inventory Locations"
            }
        },
        {
            name: "ScheduledTasks",
            path: "scheduled-tasks/:taskId?",
            components: {
                default: TasksPage,
                header: DefaultHeader
            },
            meta: {
                title: "Scheduled Tasks",
                permission: "Admin/Scheduled Tasks"
            },
            props: {
                default: (route) => ({
                    scheduled: true,
                    taskId: route.params.taskId,
                    filterSearchParams: true
                })
            }
        },
        {
            name: "TaskTemplates",
            path: "task-templates/:taskId?",
            components: {
                default: TasksPage,
                header: DefaultHeader
            },
            meta: {
                title: "Task Templates",
                permission: "Admin/Task Templates"
            },
            props: {
                default: (route) => ({
                    template: true,
                    taskId: route.params.taskId,
                    filterSearchParams: true
                })
            }
        },
        {
            name: "PrescriberContactTemplates",
            path: "prescriber-contact-templates",
            components: {
                default: PrescriberContactTemplatesPage,
                header: DefaultHeader
            },
            meta: {
                title: "Prescriber Contact Templates",
                permission: "Admin/Prescriber Contact Templates"
            }
        },
        {
            name: "TaskCompletionForms",
            path: "task-completion-forms",
            components: {
                default: TaskCompletionFormsPage,
                header: DefaultHeader
            },
            meta: {
                title: "Task Completion Forms",
                permission: "Admin/Task Completion Forms"
            }
        },
        {
            name: "TaskCompletionAnswersMergeDocuments",
            path: "task-completion-answers-merge-documents",
            components: {
                default: TaskCompletionAnswersMergeDocumentsPage,
                header: DefaultHeader
            },
            meta: {
                title: "Task Completion Answers Merge Documents",
                permission: "Admin/Task Completion Answers Merge Documents"
            }
        },
        {
            name: "TaskTriggers",
            path: "task-triggers",
            components: {
                default: TaskTriggersPage,
                header: DefaultHeader
            },
            meta: {
                title: "Task Triggers",
                permission: "Admin/Task Triggers"
            }
        },
        {
            name: "PriorAuthFaxTemplates",
            path: "prior-auth-fax-templates",
            components: {
                default: PriorAuthFaxTemplatesPage,
                header: DefaultHeader
            },
            meta: {
                title: "Prior Auth Fax Templates",
                permission: "Admin/Prior Authorization"
            }
        },
        {
            name: "CustomTextTemplates",
            path: "text-message-templates",
            components: {
                default: CustomTextTemplatesPage,
                header: DefaultHeader
            },
            meta: {
                title: "Text Message Templates",
                permission: "Admin/Custom Text Message Templates"
            }
        },
        {
            name: "EncryptionKeys",
            path: "encryption-keys",
            components: {
                default: EncryptionKeysPage,
                header: DefaultHeader
            },
            meta: {
                title: "Encryption Keys",
                permission: "Admin/Encryption Keys"
            }
        }
    ]
};

const reportsMenu = {
    path: "/reports",
    component: DashboardLayout,
    redirect: "/reports/reports",
    name: "ReportsCategory",
    children: [
        {
            path: "reports",
            name: "Reports",
            components: { default: ReportsComponent, header: DefaultHeader },
            meta: { title: "Reports" }
        },
        {
            path: "history",
            name: "History",
            components: { default: HistoryComponent, header: DefaultHeader },
            meta: { title: "Record History" }
        },
        {
            path: "access",
            name: "Access",
            components: { default: AccessLogComponent, header: DefaultHeader },
            meta: { title: "Access Report" }
        },
        {
            path: "inventory",
            name: "Inventory",
            components: { default: InventoryReportPage, header: DefaultHeader },
            meta: {
                title: "Inventory Report",
                permission: "Reports/Inventory"
            }
        },
        {
            path: "dispensed",
            name: "Dispensed",
            components: { default: DispensedPage, header: DefaultHeader },
            meta: {
                title: "Dispensed Report",
                permission: "Reports/Dispensed"
            }
        },
        {
            path: "pmpstatus",
            name: "PMP Status",
            components: { default: PMPStatusPage, header: DefaultHeader },
            meta: {
                title: "PMP Status",
                permission: "Reports/PMP Status"
            }
        },
        {
            name: "DrugShortageReport",
            path: "drug-shortage-report",
            components: {
                default: DrugShortageReportPage,
                header: DefaultHeader
            },
            meta: {
                title: "Drug Shortage Report",
                permission: "Reports/Drug Shortage Report"
            },
        },
        {
            path: "surplus",
            name: "Surplus",
            components: { default: SurplusReportsPage, header: DefaultHeader },
            meta: {
                title: "Surplus Reports",
                permission: "Reports/Surplus"
            }
        },
        {
            path: "transferredRx",
            name: "tramsferredrx-report",
            components: { default: TransferRxReportPage, header: DefaultHeader },
            meta: {
                title: "Transferred RX Reports",
                permission: "Reports/Transferred RX Report"
            }
        },
        {
            path: "notifications",
            components: { default: NotificationListPage, header: DefaultHeader },
            name: "NotificationsList",
            meta: { title: "My Notifications" }
        },
        {
            path: "patient-unique-id-lookup",
            name: "PatientUniqueIdLookup",
            components: {
                default: PatientUniqueIdLookupPage,
                header: DefaultHeader
            },
            meta: {
                title: "Patient Unique ID Lookup",
                permission: 'Other/Patient By Unique Id'
            }
        }
    ]
};

const processingMenu = {
    path: "/processing",
    component: DashboardLayout,
    redirect: "/processing/patient-dashboard",
    name: "CPHub",
    children: [
        {
            name: "Tasks",
            path: "tasks/:taskId?",
            components: {
                default: TasksPage,
                header: DefaultHeader
            },
            meta: {
                title: "Tasks",
                permission: "Processing/Tasks"
            },
            props: {
                default: route => ({
                    taskId: route.params.taskId,
                    filterSearchParams: true
                })
            }
        },
        {
            name: "PrescriptionDetails",
            path: "prescription/:storeID/:rxNumber/:rfNumber",
            components: {
                default: PrescriptionDetailsPage,
                header: DefaultHeader
            },
            meta: {
                title: "Prescription Details"
            }
        },
        {
            name: "PrescriptionDetailsId",
            path: "prescription/:rxId",
            components: {
                default: PrescriptionDetailsPage,
                header: DefaultHeader
            },
            meta: { title: "Prescription Details" }
        },
        {
            name: "Prescription",
            path: "prescription",
            components: {
                default: PrescriptionDetailsPage,
                header: DefaultHeader
            },
            props: {
                default: (route) => {
                    // Convert string "null" to actual null for specific props
                    const query = { ...route.query };
                    if (query.imageID === "null" || query.imageID === "undefined") query.imageID = null;
                    if (query.escriptID === "null" || query.escriptID === "undefined") query.escriptID = null;
                    if (query.queueItemID === "null" || query.queueItemID === "undefined") query.queueItemID = null;
                    if (query.programTransfer === "null" || query.programTransfer === "undefined") query.programTransfer = null;
                    return query;
                }
            },
            meta: { title: "Prescription Details" }
        },
        {
            name: "OrderDetails",
            path: "order/:orderId",
            components: {
                default: OrderDetailsPage,
                header: DefaultHeader
            },
            meta: { title: "Order Details" }
        },
        {
            name: "OrderPickup",
            path: "order-pickup/:orderId",
            components: {
                default: OrderDetailsPage,
                header: DefaultHeader
            },
            params: { mode: "pickup" },
            meta: { title: "Order Pickup" }
        },
        {
            name: "OrderVerification",
            path: "order-verification/:orderId/",
            components: {
                default: OrderDetailsPage,
                header: DefaultHeader
            },
            params: {
                mode: "verify"
            },
            meta: { title: "Order Verification" }
        },
        {
            name: "Order",
            path: "order-patient/:patientId/",
            components: {
                default: OrderDetailsPage,
                header: DefaultHeader
            },
            meta: { title: "Order Details" }
        },
        {
            name: "Ingestion",
            path: "ingestion/:id?",
            components: { default: IngestionComponent, header: DefaultHeader },
            meta: {
                title: "Rx Intake",
                permission: "Processing/Rx Intake Queue/View"
            }
        },
        {
            name: "ManualFax",
            path: "manual-fax",
            components: { default: ManualFaxComponent, header: DefaultHeader },
            meta: {
                title: "Manual Fax",
                permission: "Services/Manual Fax"
            }
        },
        {
            name: "Audit",
            path: "audit/:id",
            components: {
                default: PrescriptionVerificationDetailsPage,
                header: DefaultHeader
            },
            meta: { title: "Audit Details" }
        },
        {
            name: "PV2",
            path: "pv2/prescription/:storeID/:rxNumber/:rfNumber",
            components: {
                default: PrescriptionVerificationDetailsPage,
                header: DefaultHeader
            },
            meta: { title: "Prescription Verification" }
        },
        {
            name: "PV1",
            path: "pv1/prescription/:storeID/:rxNumber/:rfNumber",
            components: {
                default: PrescriptionVerificationDetailsPage,
                header: DefaultHeader
            },
            meta: { title: "Prescription Verification" }
        },
        {
            name: "PrescriptionVerification",
            path: "prescription-verification/:pvNbr",
            components: {
                default: PrescriptionVerificationDetailsPage,
                header: DefaultHeader
            },
            meta: { title: "Prescription Verification" }
        },
        {
            name: "VerificationQueue",
            path: "verification-queue",
            components: {
                default: VerificationQueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "Verification Queue",
                permission: "Pharmacists/Verification Queue"
            }
        },
        {
            name: "PV1QueuePage",
            path: "pv1-queue",
            components: {
                default: PV1QueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "PV1 Queue",
                anyPermission: ["Pharmacists/PV1 Queue", "Other/View PV1 Queue"]
            }
        },
        {
            name: "OnHoldQueue",
            path: "on-hold-queue",
            components: {
                default: PrescriptionOnHoldQueue,
                header: DefaultHeader
            },
            meta: {
                title: "On Hold Queue",
                permission: "Processing/On Hold Report"
            }
        },
        {
            name: "ActiveQueue",
            path: "active-script-queue",
            components: {
                default: ActiveQueue,
                header: DefaultHeader
            },
            meta: {
                title: "Active Prescription Queue",
                permission: "Processing/Active Queue"
            }
        },
        {
            name: "PrintQueue",
            path: "print-queue",
            components: {
                default: PrintQueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "Print Queue",
                permission: "Dispensing/Print Queue"
            }
        },
        {
            name: "StalePrintQueue",
            path: "stale-print-queue",
            components: {
                default: PrintQueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "Stale Print Queue",
                permission: "Dispensing/Stale Print Queue"
            }
        },
        {
            name: "TransferMyRxQueue",
            path: "transfer-my-rx",
            components: {
                default: TransferMyRxQueuePage,
                header: DefaultHeader
            },
            meta: { title: "Transfer My Rx Queue" }
        },
        {
            name: "OrderAuditConfigs",
            path: "order-audit-configs",
            components: {
                default: OrderAuditConfigPage,
                header: DefaultHeader
            },
            meta: { title: "Order Audit Configs" }
        },
        {
            name: "OrderAuditQueue",
            path: "order-audit-queue",
            components: {
                default: OrderAuditQueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "Order Audit Queue",
                permission: "Processing/Order Audit Queue"
            }
        },
        {
            name: "OrderAuditDetails",
            path: "order-audit/:id",
            components: {
                default: OrderAuditDetails,
                header: DefaultHeader
            },
            meta: {
                title: "Order Audit"
            }
        },
        {
            name: "PatientInsuranceQueue",
            path: "patient-insurance-queue/:insuranceId?",
            components: {
                default: PatientInsuranceQueue,
                header: DefaultHeader
            },
            meta: {
                title: "Insurance Queue",
                permission: "Processing/Patient Insurance"
            }
        },
        {
            name: "PatientWebAllergyUpdateQueue",
            path: "patient-web-allergy-update-queue/:allergyId?",
            components: {
                default: PatientWebAllergyUpdateQueue,
                header: DefaultHeader
            },
            meta: {
                title: "Allergy Queue",
                permission: "Processing/Patient Allergy Updates"
            }
        },
        {
            name: "OnlineOrderQueue",
            path: "online-order-queue/:orderId?",
            components: {
                default: OnlineOrderQueue,
                header: DefaultHeader
            },
            meta: {
                title: "Online Order Queue",
                permission: "Processing/Online Order Queue"
            }
        },
        {
            name: "PartialPaymentQueue",
            path: "partial-payment-queue",
            components: {
                default: PartialPaymentQueue,
                header: DefaultHeader
            },
            meta: {
                title: "Partial Payment Queue",
                permission: "Processing/Partial Payment Queue"
            }
        },
        {
            name: "ConsignmentQueue",
            path: "consignment-queue",
            components: {
                default: ConsignmentQueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "Consignment Queue",
                permission: "Services/Consignment Queue"
            }
        },
        {
            name: "IncompleteAnswersQueue",
            path: "incomplete-answers-queue",
            components: {
                default: IncompleteAnswersQueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "Incomplete Answers Queue",
                permission: "Services/Incomplete Answers Queue"
            }
        },
        {
            name: "VoicemailsNew",
            path: "voicemails-queue",
            components: {
                default: Voicemails,
                header: DefaultHeader
            },
            meta: {
                title: "Voicemails",
                permission: "Services/Voicemails"
            }
        },
        {
            name: "Voicemails",
            path: "voicemails-queue/:id",
            components: {
                default: Voicemails,
                header: DefaultHeader
            },
            meta: { title: "Voicemails" }
        },
        {
            name: "InventoryBatchQueuePage",
            path: "inventory-batch-queue",
            components: {
                default: InventoryBatchQueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "Inventory Batch Queue",
                permission: "Purchasing/Inventory Batch Queue"
            }
        },
        {
            name: "RxTransferQueue",
            path: "RxTransferQueue/:transferId?",
            components: {
                default: RxTransferQueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "Transfer Queue",
                permission: "Pharmacists/Rx Transfers/Complete Transfer"
            }
        },
        {
            name: "BulkTransferOut",
            path: "bulk-transfer-out",
            components: {
                default: BulkTransferOutPage,
                header: DefaultHeader
            },
            meta: {
                title: "Bulk External Transfer",
                permission: "Pharmacists/Rx Transfers/Bulk Transfer"
            }
        },
        {
            name: "PendingForBillingQueuePage",
            path: "pending-billing-prescriptions-queue",
            components: {
                default: PendingForBillingQueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "Billing Queue",
                permission: "Processing/Pending Billing Queue"
            }
        },
        {
            name: "AutorefillQueuePage",
            path: "autorefill-queue",
            components: {
                default: AutorefillQueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "Autorefill Queue",
                permission: "Processing/Autorefill Queue"
            }
        },
        {
            name: "MedSyncQueue",
            path: "medsync-queue",
            components: {
                default: MedSyncQueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "MedSync Queue",
                permission: "Processing/MedSync Queue"
            }
        },
        {
            name: "MedSyncOpportunities",
            path: "medsync-opportunities",
            components: {
                default: MedSyncOpportunitiesPage,
                header: DefaultHeader
            },
            meta: {
                title: "MedSync Opportunities",
                permission: "Processing/MedSync Opportunities"
            }
        },
        {
            name: "ReversalQueuePage",
            path: "reversal-queue",
            components: {
                default: ReversalQueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "Reversal Queue",
                permission: "Processing/Reversal Queue"
            }
        },
        {
            name: "ExpiredOnOrderPage",
            path: "expired-on-order",
            components: {
                default: ExpiredOnOrderPage,
                header: DefaultHeader
            },
            meta: {
                title: "Expired on Order",
                permission: "Processing/Expired on Order"
            }
        },
        {
            name: "DoctorFollowUpQueue",
            path: "doctor-followup-queue",
            redirect: "doctor-followup"
        },
        {
            name: "DoctorFollowUp",
            path: "doctor-followup",
            components: {
                default: DoctorFollowUpQueue,
                header: DefaultHeader
            },
            meta: {
                title: "Doctor Follow-Ups",
                permission: "Processing/Doctor Follow Ups"
            }
        },
        {
            name: "PatientDashboard",
            path: "patient-dashboard/:id?",
            components: {
                default: PatientDashboardPage,
                header: DefaultHeader
            },
            meta: {
                title: "Patient Dashboard",
                permission: "Customer Service/Patient"
            },
            props: { default: true }
        },
        {
            name: "PriorAuthorizationList",
            path: "prior-authorizations",
            components: {
                default: PriorAuthorizationListPage,
                header: DefaultHeader
            },
            meta: {
                title: "Prior Authorizations",
                permission: "Services/Prior Authorization"
            },
            props: {
                default: route => ({
                    status: route.query.status,
                    storeId: route.query.storeId,
                    programId: route.query.programId
                })
            }
        },
        {
            name: "ElectronicPriorAuthorization",
            path: "electronic-prior-authorizations",
            components: {
                default: ElectronicPriorAuthorizationListPage,
                header: DefaultHeader
            },
            meta: {
                title: "Electronic Prior Authorizations",
                permission: "Services/Electronic PA"
            }
        },
        {
            name: "DispenseErrors",
            path: "dispense-errors",
            components: {
                default: ReportedErrorsPage,
                header: DefaultHeader
            },
            meta: {
                title: "Errors",
                permission: "Processing/Rx Errors"
            }
        },
        {
            name: "PendingDispenseErrors",
            path: "pending-errors",
            components: {
                default: PendingToAcceptErrorsPage,
                header: DefaultHeader
            },
            meta: {
                title: "Errors - Pending",
                permission: "Pharmacists/Corrected Errors/Accept Error"
            }
        },
        {
            name: "DoctorDashboard",
            path: "doctor-dashboard",
            components: {
                default: DoctorDashboard,
                header: DefaultHeader
            },
            meta: {
                title: "Doctor Dashboard",
                permission: "Customer Service/Doctor"
            }
        },
        {
            name: "DrugDashboard",
            path: "drug-dashboard",
            components: {
                default: DrugDashboard,
                header: DefaultHeader
            },
            meta: {
                title: "Drug Dashboard",
                permission: "Customer Service/Drugs"
            }
        },
        {
            name: "ProgramDashboard",
            path: "program-dashboard",
            components: {
                default: ProgramDashboard,
                header: DefaultHeader
            },
            meta: {
                title: "Program Dashboard",
                permission: "Customer Service/Programs"
            }
        },
        {
            name: "RxAudit",
            path: "rx-audit",
            components: {
                default: RxAuditVerificationPage,
                header: DefaultHeader
            },
            meta: {
                title: "Rx Audit Verification",
                permission: "Compliance/Rx Audit Verification"
            }
        },
        {
            name: "PickupQueue",
            path: "pickup-queue",
            components: {
                default: PickupQueuePage,
                header: DefaultHeader
            },
            meta: {
                title: "Pickup Queue",
                permission: "Dispensing/Pickup Queue"
            }
        },
        {
            name: "VerifiedNotShippedQueue",
            path: "verified-not-shipped-queue",
            components: {
                default: VerifiedNotShippedQueue,
                header: DefaultHeader
            },
            meta: {
                title: "Verified Not Shipped",
                permission: "Dispensing/Verified Not Shipped"
            },
        },
        {
            name: "ReturnToSender",
            path: "return-to-sender",
            components: {
                default: ReturnToSenderPage,
                header: DefaultHeader
            },
            meta: {
                title: "Return To Sender",
                permission: "Processing/Return to Sender"
            }
        },
        {
            name: "AuditTracking",
            path: "audit-tracking",
            components: {
                default: AuditTrackingPage,
                header: DefaultHeader
            },
            meta: {
                title: "Audit Tracking",
                permission: "Compliance/Audit Tracking"
            }
        },
        {
            name: "PatientAssistanceProgramQueue",
            path: "pap-queue",
            components: {
                default: PatientAssistanceProgramQueue,
                header: DefaultHeader
            },
            meta: {
                title: "Patient Assistance Program Queue",
                permission: "Processing/PAP Queue"
            }
        },
        {
            path: "plaid",
            name: "Plaid Page",
            components: { default: PlaidPage, header: DefaultHeader },
            meta: { title: "Plaid Testing" },
        },
        {
            name: "EDIOrdering",
            path: "edi-ordering",
            components: {
                default: Ordering,
                header: DefaultHeader
            },
            meta: {
                title: "EDI Ordering",
                permission: "Purchasing/EDI Ordering"
            }
        },
        {
            name: "EDIOrderDetails",
            path: "edi-ordering/:id",
            components: {
                default: EDIOrderDetails,
                header: DefaultHeader
            },
            meta: { title: "EDI Order Details" }
        },
        {
            path: "calllog",
            name: "CallLog",
            components: { default: CallLogPage, header: DefaultHeader },
            meta: {
                title: "Call Log",
                permission: "Reports/Call Log"
            }
        },
        {
            path: "filling",
            name: "Filling",
            components: {
                default: FillingPage,
                header: DefaultHeader
            },
            meta: {
                title: "Filling",
                permission: "Dispensing/Filling"
            }
        },
        {
            path: "shipping",
            name: "Shipping",
            components: {
                default: ShippingPage,
                header: DefaultHeader
            },
            meta: {
                title: "Shipping",
                permission: "Dispensing/Shipping"
            }
        },
    ]
};

const flexMenu = {
    path: "/flex",
    component: Content,
    redirect: "/flex/embed",
    name: "Flex",
    children: [
        {
            name: "FlexEmbed",
            path: "embed/:phoneNumber/:callSid?",
            components: {
                default: FlexEmbed,
                header: DefaultHeader,
            },
            meta: { title: "Flex Embed" }
        },
        {
            name: "FlexEmbedEmpty",
            path: "embed",
            components: {
                default: FlexEmbed,
                header: DefaultHeader,
            },
            meta: { title: "Flex Embed" }
        },
        {
            name: "PatientDashboardFlex",
            path: "patient-dashboard/:id",
            components: {
                default: PatientDashboardPage,
                header: DefaultHeader
            },
            meta: { title: "Patient Dashboard" },
            props: { default: true }
        },
        {
            name: "PrescriberDetailsFlex",
            path: "prescriber-details/:id",
            components: {
                default: DoctorDetailsPage,
                header: DefaultHeader
            },
            meta: { title: "Prescriber Details" },
            props: { default: true }
        },
        {
            name: "DoctorDashboardFlex",
            path: "doctor-dashboard",
            components: {
                default: DoctorDashboard,
                header: DefaultHeader
            },
            meta: { title: "Doctor Dashboard" }
        },
    ]
};

const routes = [
    {
        path: "/",
        name: "Home",
        component: Login
    },
    processingMenu,
    maintenanceMenu,
    reportsMenu,
    flexMenu,
    {
        path: "/",
        component: DashboardLayout,
        redirect: "/dashboard",
        name: "DashboardCategory",
        children: [
            {
                path: "dashboard",
                name: "Dashboard",
                components: { default: Dashboard, header: DashboardHeader },
                meta: {
                    title: "Dashboard",
                    permission: "Dashboard/View Dashboard"
                }
            }
        ]
    },
    {
        path: "/adhoc-reporting",
        component: DashboardLayout,
        name: "AdHocDashboardCategory",
        children: [
            {
                path: ":dashboardId?",
                name: "AdhocDashboard",
                components: { default: AdhocDashboard, header: DefaultHeader },
                props: { default: true },
                meta: {
                    title: "Analytics",
                    permission: "Analytics/View Dashboard"
                }
            }
        ],
    },
    {
        path: "/login",
        redirect: "/"
    },
    {
        path: "*",
        component: DashboardLayout,
        children: [
            {
                path: "unauthorized",
                components: {
                    default: UnauthorizedPage,
                    header: DefaultHeader
                },
                meta: {
                    title: "Unauthorized"
                }
            },
            {
                path: "*",
                components: {
                    default: NotFound,
                    header: DefaultHeader,
                },
                meta: {
                    title: "Not Found"
                }
            }
        ]
    }
];

export default routes;
